import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, Card, MenuItem } from "@mui/material";
import { useParams } from "react-router-dom";
import api from "api/api";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FormControl, InputLabel, Select } from "@mui/material";
import Alert from "react-bootstrap/Alert";
import "bootstrap/dist/css/bootstrap.min.css";

function UpdateFaqForm() {
  const { id } = useParams();
  const [formData, setFormData] = useState({ question: "", answer: "", isActive: true });
  const [alert, setAlert] = useState({ show: false, message: "", variant: "" });

  // Alert handler
  const showAlert = (message, variant = "danger") => {
    setAlert({ show: true, message, variant });
    setTimeout(() => setAlert({ show: false, message: "", variant: "" }), 3000);
  };

  // Load FAQ data
  useEffect(() => {
    if (!id) return;

    api
      .get(`admin/faq/edit/${id}`)
      .then(({ data }) => {
        if (data.status && data.data) {
          const { question, answer, isActive } = data.data;
          setFormData({ question, answer, isActive });
        } else {
          showAlert(data.message);
        }
      })
      .catch(() => showAlert("Failed to fetch FAQ data."));
  }, [id]);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: name === "isActive" ? value === "true" : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post(`admin/faq/update/${id}`, formData);
      showAlert(data.message, data.status ? "success" : "danger");
    } catch {
      showAlert("Update failed.");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Update FAQ
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                {alert.show && (
                  <Alert
                    variant={alert.variant}
                    dismissible
                    onClose={() => setAlert({ show: false })}
                  >
                    {alert.message}
                  </Alert>
                )}

                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        label="Question"
                        name="question"
                        value={formData.question}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <label style={{ marginBottom: "5px", display: "block" }}>Answer</label>
                      <CKEditor
                        editor={ClassicEditor}
                        data={formData.answer}
                        onChange={(_, editor) =>
                          setFormData((prev) => ({ ...prev, answer: editor.getData() }))
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <FormControl fullWidth variant="outlined" size="small" margin="normal">
                        <InputLabel>Status</InputLabel>
                        <Select
                          label="Status"
                          name="isActive"
                          value={String(formData.isActive)}
                          onChange={handleChange}
                        >
                          <MenuItem value="true">Active</MenuItem>
                          <MenuItem value="false">Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <Button type="submit" className="btn" variant="contained" color="info">
                        Update
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UpdateFaqForm;
